const updateSessionShipTo = (sessionContext, addressId, shipToUnit, sessionHeaders, history) => {
  sessionContext.replace({
    ...sessionContext,
    cartId: null,
    addressId,
    shipToUnit: {
      shipToId: shipToUnit?.shipToId,
      distributionChannel: shipToUnit?.distributionChannel,
      division: shipToUnit?.division,
      salesOrganization: shipToUnit?.salesOrganization,
      billToId: shipToUnit?.billToId,
      soldToId: shipToUnit?.soldToId,
      countryCode: shipToUnit.country.code,
      countryName: shipToUnit.country.name,
      currency: shipToUnit?.currency,
      isBlocked: shipToUnit?.isBlocked
    },
    currentAddress: addressId
  });

  const updatedHeaders = [];
  if (shipToUnit?.shipToId)
    updatedHeaders.push({ name: 'shipToId', value: shipToUnit.shipToId });
  if (shipToUnit?.currency)
    updatedHeaders.push({ name: 'currency', value: shipToUnit?.currency });
  else {
    const { userCurrency } = sessionContext;
    updatedHeaders.push({ name: 'currency', value: userCurrency });
  }
  if (updatedHeaders.length) sessionHeaders.setSessionHeader(updatedHeaders);
  if (history) history.push('/content/homepage');
};

export default updateSessionShipTo;